import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'

export default function TableColor() {
    return (
        <>
            <Breadcrumb title="Table Color" path="Tabels / Table Color" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15 mb-30'>
                <div className='mb-30'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                        Table Dark
                    </p>
                </div>
                <div className='overflow-auto'>
                    <table className='w-full min-w-[767px] bg-black-50 text-white'>
                        <thead>
                            <tr>
                                <th align='left' className='border-t border-b-2 border-white-opacity p-3'>
                                    #
                                </th>
                                <th align='left' className='border-t border-b-2 border-white-opacity p-3'>
                                    FIRST NAME
                                </th>
                                <th align='left' className='border-t border-b-2 border-white-opacity p-3'>
                                    LAST NAME
                                </th>
                                <th align='left' className='border-t border-b-2 border-white-opacity p-3'>
                                    USERNAME
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='odd:bg-white-opacity'>
                                <td className='p-3 border-t border-white-opacity'>
                                    1
                                </td>
                                <td className='p-3 border-t border-white-opacity'>
                                    Mark
                                </td>
                                <td className='p-3 border-t border-white-opacity'>
                                    Otto
                                </td>
                                <td className='p-3 border-t border-white-opacity'>
                                    @mdo
                                </td>
                            </tr>
                            <tr className='odd:bg-white-opacity'>
                                <td className='p-3 border-t border-white-opacity'>
                                    2
                                </td>
                                <td className='p-3 border-t border-white-opacity'>
                                    Jacob
                                </td>
                                <td className='p-3 border-t border-white-opacity'>
                                    Thornton
                                </td>
                                <td className='p-3 border-t border-white-opacity'>
                                    @fat
                                </td>
                            </tr>
                            <tr className='odd:bg-white-opacity'>
                                <td className='p-3 border-t border-white-opacity'>
                                    3
                                </td>
                                <td className='p-3 border-t border-white-opacity'>
                                    Larry
                                </td>
                                <td className='p-3 border-t border-white-opacity'>
                                    The Bird
                                </td>
                                <td className='p-3 border-t border-white-opacity'>
                                    @twitter
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='grid lg:grid-cols-2 grid-cols-1 gap-30 mb-30'>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='mb-30'>
                        <p className='text-[16px]/[19.2px] font-medium'>
                            Table Head Dark
                        </p>
                    </div>
                    <div className='overflow-auto'>
                        <table className='w-full min-w-[549px]'>
                            <thead className='bg-black-50 text-white'>
                                <tr>
                                    <th align='left' className='border-t border-b-2 border-border p-3'>
                                        #
                                    </th>
                                    <th align='left' className='border-t border-b-2 border-border p-3'>
                                        FIRST NAME
                                    </th>
                                    <th align='left' className='border-t border-b-2 border-border p-3'>
                                        LAST NAME
                                    </th>
                                    <th align='left' className='border-t border-b-2 border-border p-3'>
                                        USERNAME
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='p-3 border-t border-border'>
                                        1
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Mark
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Otto
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        @mdo
                                    </td>
                                </tr>
                                <tr>
                                    <td className='p-3 border-t border-border'>
                                        2
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Jacob
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Thornton
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        @fat
                                    </td>
                                </tr>
                                <tr>
                                    <td className='p-3 border-t border-border'>
                                        3
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Larry
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        The Bird
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        @twitter
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <div className='mb-30'>
                        <p className='text-[16px]/[19.2px] font-medium'>
                            Table Head Dark
                        </p>
                    </div>
                    <div className='overflow-auto'>
                        <table className='w-full min-w-[549px]'>
                            <thead className='bg-bg-light-100'>
                                <tr>
                                    <th align='left' className='border-t border-b-2 border-border p-3'>
                                        #
                                    </th>
                                    <th align='left' className='border-t border-b-2 border-border p-3'>
                                        FIRST NAME
                                    </th>
                                    <th align='left' className='border-t border-b-2 border-border p-3'>
                                        LAST NAME
                                    </th>
                                    <th align='left' className='border-t border-b-2 border-border p-3'>
                                        USERNAME
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='p-3 border-t border-border'>
                                        1
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Mark
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Otto
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        @mdo
                                    </td>
                                </tr>
                                <tr>
                                    <td className='p-3 border-t border-border'>
                                        2
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Jacob
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Thornton
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        @fat
                                    </td>
                                </tr>
                                <tr>
                                    <td className='p-3 border-t border-border'>
                                        3
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        Larry
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        The Bird
                                    </td>
                                    <td className='p-3 border-t border-border'>
                                        @twitter
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15 mb-30'>
                <div className='mb-30'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                        Gradient Color Background
                    </p>
                </div>
                <div className='overflow-auto'>
                    <table className='w-full min-w-[767px]'>
                        <thead>
                            <tr>
                                <th align='left' className='border-t border-b-2 border-border p-3'>
                                    #
                                </th>
                                <th align='left' className='border-t border-b-2 border-border p-3'>
                                    FIRST NAME
                                </th>
                                <th align='left' className='border-t border-b-2 border-border p-3'>
                                    LAST NAME
                                </th>
                                <th align='left' className='border-t border-b-2 border-border p-3'>
                                    USERNAME
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='bg-gradient-to-r from-rose-400 to-rose-300'>
                                <td className='p-3 border-t border-border'>
                                    1
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Mark
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Otto
                                </td>
                                <td className='p-3 border-t border-border'>
                                    @mdo
                                </td>
                            </tr>
                            <tr className='bg-gradient-to-r from-amber-400 to-amber-300'>
                                <td className='p-3 border-t border-border'>
                                    2
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Jacob
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Thornton
                                </td>
                                <td className='p-3 border-t border-border'>
                                    @fat
                                </td>
                            </tr>
                            <tr className='bg-gradient-to-r from-emerald-400 to-emerald-300'>
                                <td className='p-3 border-t border-border'>
                                    3
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Larry
                                </td>
                                <td className='p-3 border-t border-border'>
                                    The Bird
                                </td>
                                <td className='p-3 border-t border-border'>
                                    @twitter
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}
